import './style.scss';
import { DateTime } from 'luxon';
import type { ILine } from '../../../../models/line.model';
import { TranslationService } from '../../../../services/translation.service';
import { ConfigurationService } from '../../../../services/configuration.service';
import LineDescription from '../../../Shared/LineDescription';
import { TransportMode } from '../../../../models/transport-mode.enum';
import { LineHelper } from '../../../../helpers/line.helper';

function createLinkText(line: ILine) {
  let result = `${TranslationService.get('timetablespage.timetablelinktext')} ${TranslationService.get('common.line').toLocaleLowerCase()} ${LineHelper.getLineName(line)} ${line.directionName}`;
  if (!!line.appliesFrom && line.appliesFrom > DateTime.now()) {
    result = `${result} (${TranslationService.get('common.from').toLocaleLowerCase()} ${line.appliesFrom.toFormat('yyyy-MM-dd')})`;
  }
  return result;
}

function TimetablesLine({ line, className }: { line: ILine; className?: string }) {
  const linkUrl = `${ConfigurationService.get('timetablespage.baseurl')}${line.gid}/`;

  return (
    <div className={`timetables-line print-no-break ${className ?? ''}`}>
      <div className="timetables-line__content-wrapper p-3">
        <LineDescription line={line} showTransportMode={true} showDirectionName={line.transportMode === TransportMode.train} showAppliesFromDateOnFutureLines={true} className="mb-2" />
        <a className="timetables-line__link-wrapper" href={linkUrl}>
          {createLinkText(line)}
        </a>
      </div>
    </div>
  );
}

export default TimetablesLine;
